import { FETCH_PROJECT_SUCCESS } from "~/store/action_types";

const projectHourlyRates = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PROJECT_SUCCESS: {
      const { projectId } = action;
      const hourlyRates = action?.response?.result?.hourly_rates;

      if (projectId) {
        return { ...state, [projectId]: hourlyRates };
      }

      return state;
    }
    default:
      return state;
  }
};

export default projectHourlyRates;
